import React from "react";
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import CardBackground from "../../../components/MainTemplate/CardBackground";
import UserAddChild from "./UserAddChild";

const UserAdd = () => {
  return (
    <MainTemplate>
      <CardBackground>
        <UserAddChild />
      </CardBackground>
    </MainTemplate>
  );
};

export default UserAdd;
